import { render } from "./Pdpa.vue?vue&type=template&id=7968f4f1"
import script from "./Pdpa.vue?vue&type=script&lang=js"
export * from "./Pdpa.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__